// @flow

import React from 'react';
import type {Element} from 'react';

export default function ShowBanner({banner}: {banner: string}): Element<any> {
  return <div className="row inner-page-content">
    <div className="small-12 columns show-banner" dangerouslySetInnerHTML={ {__html: banner} } />
  </div>;
}